export default "__VITE_ASSET__DuNSrier__"